/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import Search from "../../images/icons/search.svg";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import {
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import Utils from "../../utils/utils";
import PregnantAccordion from "../../componentes/pregnantSearch/pregnantAccordion";
import PregnantSearch from "../../componentes/pregnantSearch/pregnantSearch";
import { getMaestras } from "../../actions/maestras-actions";
import { cancelMaternityLicenceAsync, getFilterMaternityLicence } from "../../actions/licence-motherhood-actions";
import { permissionsConstans } from "../../constansPermissions";
const _ = require("lodash");

const Pregnants = (props) => {
  const [{ filterPregnant, breadCrumb }, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [hasEdition, setHasEdition] = useState(false);
  const [message, setMessage] = useState({
    open: false,
    description: "",
    handleClickOut: () => { },
    handleClick: () => { },
    buttonOneText: "",
    oneButtons: false,
    type: "",
  });
  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  useEffect(() => {
    getListaMaestras();
  }, []);

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => { },
    handleClick: () => { },
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
  });

  const [filter, setFilter] = useState({
    employeeSurname: null,
    licenseStartDate: null,
    regional: null,
    employeeName: null,
    licenseEndDate: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "requestDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const { path } = useRouteMatch();

  const getPregs = async () => {

    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var licenseStartDate = filter.licenseStartDate
      ? Utils.getFormattedDateyyyyMMdd(filter.licenseStartDate, "-")
      : null;
    const response = await getFilterMaternityLicence(
      {
        licenseStartDate: licenseStartDate,
        licenseEndDate: filter.licenseEndDate
          ? filter.licenseEndDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        regionalId: filter.regional === "" ? null : filter.regional,
        employeeName: filter.employeeName === "" ? null : filter.employeeName,
        employeeSurname: filter.employeeSurname === "" ? null : filter.employeeSurname,

      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response?.data) {
      const data = response.data.maternityLicencePage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  if (breadCrumb?.isCreatePregnantStartProcess) {
    setTimeout(() => {
      props.history.push(`${path}/crear`);
    }, 100);
  }

  useEffect(() => {
    getPregs();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Consultar registro de embarazos",
      breadCrumbSubText: "Consultar registro de embarazos",
      index: 30,
    });
  }, [paginadorRequest, hasEdition]);

  if (
    filterPregnant &&
    filterPregnant?.isFilter &&
    filter !== filterPregnant.filter
  ) {
    var newfilter = filterPregnant.filter;
    filter.licenseStartDate = newfilter.licenseStartDate;
    filter.licenseEndDate = newfilter.licenseEndDate;
    filter.employeeName = newfilter.employeeName;
    filter.employeeSurname = newfilter.employeeSurname;
    filter.regional = newfilter.regional;

    paginadorRequest.page = 0;
    getPregs();
    dispatch({
      type: "SET_FILTER_PREGNANT",
      isFilter: false,
    });
  }

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
    }));
  };

  const closeMessage = (event) => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    if (event === "closeModal") closeModal();
  };

  const handleCancelLicence = async (comm, id) => {
    const response = await cancelMaternityLicenceAsync({
        observation: comm,
        maternityLicenceId: id
    });
    if (response && (response?.status === 200 || response?.status === 201)) {
      setMessage({
        description: `El registro de embarazo se ha editado de forma exitosa.`,
        textButtonSubmit: "Volver",
        handleClick: () => { closeMessage("closeModal") },
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      getPregs();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
        ? response?.data?.detail
        : response?.data?.error
        ? response?.data?.error
        : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  }

  const onCancel = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea anular el registro?",
      handleClick: (comm) => handleCancelLicence(comm, id),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
    }));
  };

  const validationPermissionSearch = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "MAT_LIC");
    if (module?.functionalities?.some((x) => x === permissionsConstans.MAT_LIC_CONSULTAR)){
      return (
        <PregnantSearch />
      )
    }
  };

  return (
    <div style={{ marginTop: "25px" }}>
      <ModalConfirmBase
        open={message.open}
        description={message.description}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        oneButtons={message.oneButtons}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />
      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
      />

      {validationPermissionSearch()}

      { paginadorResponse.data.map((row, index) => (
        <PregnantAccordion
          headers={headers}
          data={row}
          handleCancel={onCancel}
          maestras={maestras}
          hasEdition={hasEdition}
          setHasEdition={setHasEdition}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default withRouter(Pregnants);
